import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d460962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-avatar-container" }
const _hoisted_2 = { class: "select-avatar__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header-title" }, "上传头像")
], -1))


const __default__ = {
  name: 'SelectAvatarDialogNew'
}

import { useMessage } from 'naive-ui'
import Icon from '@teams/common/components/icon'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    onConfirm: null,
    onCancel: null,
    modelValue: null
  },
  emits: ['close', 'back', 'closeAll'],
  setup(__props: any, { emit }) {

const props = __props as { onConfirm?: (value: string) => Promise<void>, onCancel?: () => void, modelValue?: string }



const message = useMessage()
const uploadProps = {
  headerOptions: {
    isShow: false
  },
  footerOptions: {
    isShow: true
  }
}

const confirm = (value?: string) => {
  try {
    if (value) {
      if (props.onConfirm) {
        props.onConfirm(value)
      } else {
        emit('back')
      }
    } else {
      message.error('请选择要上传的照片')
    }
  } catch (error) {}
}

const back = () => {
  try {
    if (props.onCancel) {
      props.onCancel()
    } else {
      emit('back')
    }
  } catch (error) {}
}

return (_ctx: any,_cache: any) => {
  const _component_k_upload_avatar = _resolveComponent("k-upload-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        class: "header__icon header__icon--close",
        onClick: back
      }, [
        _createVNode(_unref(Icon), {
          name: "close",
          size: 16
        })
      ])
    ]),
    _createVNode(_component_k_upload_avatar, _mergeProps(uploadProps, {
      icon: __props.modelValue,
      onOnConfirm: confirm,
      onOnClose: back,
      onOnCancel: back
    }), null, 16, ["icon"])
  ]))
}
}

})